import { useCallback } from 'react';
import type { TextResult } from '@core-api/presentation/types/response';
import {
  usePreviewResultsIterator,
  getWordCloudPreviewResultsIteration,
} from '@mentimeter/slides-preview-results';

interface UseWordCloudPreviewResultsProps {
  isEnabled: boolean;
}

export const useWordCloudPreviewResults = ({
  isEnabled,
}: UseWordCloudPreviewResultsProps): TextResult[] => {
  const getNextResults = useCallback(
    (iteration: number, previous: TextResult[] = []) => {
      return getWordCloudPreviewResultsIteration({
        iteration,
        previous,
      });
    },
    [],
  );

  return usePreviewResultsIterator(isEnabled, getNextResults) ?? [];
};
